// extracted by mini-css-extract-plugin
export default {"contentItemContainer":"ContentContainer_contentItemContainer__BRQFP"};